import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import Loading from "../Loading";
import * as Yup from "yup";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";

const EditPropertie = ({
  editPropertieMutate,
  editEntryLoading,
  setEditUser,
  selectedData,
}) => {
  const SubmitHandler = (values) => {
    editPropertieMutate(values);
  };

  const formik = useFormik({
    initialValues: {
      name: selectedData?.name || "",
      ownerMobile: selectedData?.ownerMobile || "",
      status: selectedData?.status || "",
      id: selectedData?.id || "",
      lockInPeriod: selectedData?.lockInPeriod || "",
      noticePeriod: selectedData?.noticePeriod || "",
      // ownerName: selectedData?.ownerName || "",
      address: selectedData?.address || "",
      streetAddress: selectedData?.streetAddress || "",
      pincode: selectedData?.pincode || "",
      clientId: selectedData?.clientId || "",
      type: selectedData?.type || "",
      isGroundIncluded: selectedData?.isGroundIncluded || 0,
      floorCount: selectedData?.floorCount || "",
      isStampPaperRequired: selectedData?.isStampPaperRequired || 0,
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Name is required"),
      ownerMobile: Yup.string()
        .matches(/^\d{10}$/, "Enter Valid number")
        .required("Mobile number is required"),
      status: Yup.number()
        .required("Select Status")
        .min(1, "Status can be active or inactive"),
      id: Yup.number().required("Id is required"),
      isGroundIncluded: Yup.number().required("Select an option"),
      lockInPeriod: Yup.number()
        .required("Lock In Period is required")
        .min(0, "Must be at least 0")
        .max(12, "Cannot be greater than 12")
        .typeError("Must be a number"),
      noticePeriod: Yup.number()
        .required("Notice Period is required")
        .min(0, "Must be at least 0")
        .max(12, "Cannot be greater than 12")
        .typeError("Must be a number"),
    }),
    onSubmit: SubmitHandler,
    enableReinitialize: true,
  });

  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setEditUser}>
      {editEntryLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : (
        <Wrapper>
          <Title>Edit Properties </Title>
          <form onSubmit={formik.handleSubmit}>
            <Wrapper>
              <CombineInputGroup>
               

                <InputGroup>
                  <Label htmlFor="name">Name</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      fullWidth
                      name="name"
                      id="name"
                      autoComplete="off"
                      required
                      value={formik.values.name}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.name && formik.errors.name ? (
                      <p className="text-rose-600 text-sm ">
                        {formik.errors.name}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="ownerMobile">Phone</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      name="ownerMobile"
                      id="ownerMobile"
                      // className="bg-gray-100"
                      // disabled
                      autoComplete="off"
                      required
                      value={formik.values.ownerMobile}
                      onChange={formik.handleChange}
                      maxLength={10}
                    />
                    {formik.touched.ownerMobile && formik.errors.ownerMobile ? (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.ownerMobile}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>

              <CombineInputGroup>
                {/* <InputGroup>
                  <Label htmlFor="isStampPaperRequired">
                    Stamp Paper Required
                  </Label>
                  <FieldWrapper $select={true}>
                    <Select
                      name="isStampPaperRequired"
                      id="isStampPaperRequired"
                      style={{ height: "40px" }}
                      required
                      value={formik.values.isStampPaperRequired}
                      onChange={formik.handleChange}
                      displayEmpty
                      className="w-full pl-2"
                    >
                      <MenuItem value="0">No</MenuItem>
                      <MenuItem value="1">Yes</MenuItem>
                    </Select>
                    {formik.touched.isStampPaperRequired &&
                    formik.errors.isStampPaperRequired ? (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.isStampPaperRequired}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup> */}

                 <InputGroup>
                  <Label htmlFor="clientId">Client Id</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      name="clientId"
                      id="clientId"
                      className="bg-gray-100"
                      disabled
                      autoComplete="off"
                      required
                      value={formik.values.clientId}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.clientId && formik.errors.clientId ? (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.clientId}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="status">Status</Label>
                  <FieldWrapper $select={true}>
                    <Select
                      name="status"
                      id="status"
                      style={{ height: "40px" }}
                      required
                      value={formik.values.status}
                      onChange={formik.handleChange}
                      displayEmpty
                      className="w-full pl-2"
                    >
                      <MenuItem value="1">Pending</MenuItem>
                      <MenuItem value="2">Completed</MenuItem>
                      <MenuItem value="3">Active</MenuItem>
                      <MenuItem value="4">Inactive</MenuItem>
                      <MenuItem value="5">Deleted</MenuItem>
                    </Select>
                    {formik.touched.status && formik.errors.status ? (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.status}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="lockInPeriod">Lock In Period</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      name="lockInPeriod"
                      id="lockInPeriod"
                      autoComplete="off"
                      variant="outlined"
                      value={formik.values.lockInPeriod}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (
                          /^\d{0,2}$/.test(value) &&
                          (value === "" ||
                            (Number(value) >= 0 && Number(value) <= 12))
                        ) {
                          formik.handleChange(e);
                        }
                      }}
                    />
                    {formik.touched.lockInPeriod &&
                    formik.errors.lockInPeriod ? (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.lockInPeriod}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="noticePeriod">Notice Period</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      name="noticePeriod"
                      id="noticePeriod"
                      autoComplete="off"
                      variant="outlined"
                      value={formik.values.noticePeriod}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (
                          /^\d{0,2}$/.test(value) &&
                          (value === "" ||
                            (Number(value) >= 0 && Number(value) <= 12))
                        ) {
                          formik.handleChange(e);
                        }
                      }}
                    />
                    {formik.touched.noticePeriod &&
                    formik.errors.noticePeriod ? (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.noticePeriod}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>

              <CombineInputGroup>
                {formik.values.type === 1 && (
                  <InputGroup>
                    <Label htmlFor="isGroundIncluded">Ground Included</Label>
                    <FieldWrapper $select={true}>
                      <Select
                        name="isGroundIncluded"
                        id="isGroundIncluded"
                        style={{ height: "40px" }}
                        required
                        value={formik.values.isGroundIncluded}
                        onChange={formik.handleChange}
                        displayEmpty
                        disabled={formik.values.isGroundIncluded === 1}
                        className="w-full pl-2"
                      >
                        <MenuItem value="0">No</MenuItem>
                        <MenuItem value="1">Yes</MenuItem>
                      </Select>
                      {formik.touched.isGroundIncluded &&
                      formik.errors.isGroundIncluded ? (
                        <p className="text-rose-600 text-sm">
                          {formik.errors.isGroundIncluded}
                        </p>
                      ) : null}
                    </FieldWrapper>
                  </InputGroup>
                )}

                <InputGroup>
                  <Label htmlFor="pincode">Pincode</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      fullWidth
                      name="pincode"
                      id="pincode"
                      autoComplete="off"
                      // required
                      value={formik.values.pincode}
                      onChange={formik.handleChange}
                      maxLength={6}
                      // onKeyDown={(e) => {
                      //   const allowedKeys = [
                      //     "Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"
                      //   ];

                      //   if (!/^[0-9]$/.test(e.key) && !allowedKeys.includes(e.key)) {
                      //     e.preventDefault();
                      //   }
                      // }}
                    />
                    {formik.touched.pincode && formik.errors.pincode ? (
                      <p className="text-rose-600 text-sm ">
                        {formik.errors.pincode}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>

              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="address">Address</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      fullWidth
                      name="address"
                      id="address"
                      autoComplete="off"
                      required
                      value={formik.values.address}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.address && formik.errors.address ? (
                      <p className="text-rose-600 text-sm ">
                        {formik.errors.address}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="streetAddress">Street Address</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      fullWidth
                      name="streetAddress"
                      id="streetAddress"
                      autoComplete="off"
                      required
                      value={formik.values.streetAddress}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.streetAddress &&
                    formik.errors.streetAddress ? (
                      <p className="text-rose-600 text-sm ">
                        {formik.errors.streetAddress}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </form>
        </Wrapper>
      )}
    </Model>
  );
};

const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Wrapper = tw.div`px-1  space-y-4`;
const FieldWrapper = tw.div`w-full`;
const CombineInputGroup = tw.div`flex space-x-7`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

export default EditPropertie;
